import { render, staticRenderFns } from "./treeData.vue?vue&type=template&id=3c2dea56&"
import script from "./treeData.vue?vue&type=script&lang=js&"
export * from "./treeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports